export const WEEK = 'Week';
export const DAY = 'Day';
